import type {ReactElement} from 'react';
import {useMemo} from 'react';
import React from 'react';
import {BottomBarItemColorFill} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/bottom-bar-item-color-fill';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

import {convertFabricColorToFillObject} from '@Utils/color.util';

export function VectorItemColorFill(): ReactElement<any> | null {
  const fill = useGetKeyFromActiveItem('fill');

  if (fill === undefined) {
    return null;
  }

  const fillObject = useMemo(() => {
    return convertFabricColorToFillObject(fill);
  }, [fill]);

  return <BottomBarItemColorFill type={fillObject.fillType} color={fillObject.fillColor} />;
}
